import router from '#enna/common/router'
// import AdminConfigService from './admin.config.service'

export default {
  async openAdminConfigOverview () {
    router.push({ name: 'adminconfigoverview', params: { } })
  }
}
